import React, { useCallback, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box, Button, Grid, Select, MenuItem } from '@material-ui/core/';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {
  Paper,
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow,
  TextField, Typography,
  withStyles,
} from '@material-ui/core';
import { Add, Tune, Create, GroupAdd, Delete } from '@material-ui/icons';
import { postContactList } from '../../lib/api/postContactList';
import { ProgressBar } from '../ProgressBar';
import {postApiKey, postVerifiedDomain} from "../../lib/api";
import {Key} from "@mui/icons-material";
import {toCapitalizeFromUnderScore} from "../../lib/helpers/helpers";

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    /* width: 'fit-content',*/
    '& svg':{
      marginBottom:-6,
      marginRight:4,
    },
    '& input':{
      borderColor: theme.palette.primary.main,
    }
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(3),
    marginLeft:0,
    '& svg':{
      marginBottom:-6
    }
  },
  addPatientListSmall:{
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width:180,
    height:44,
    margin:'20px auto 0px',
    fontSize:13,
    display:'block',
    '&:hover':{
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
    '& *':{
      color: theme.palette.primary.contrastText,
      display:'inline',
    }
  },
  addPatientListText:{
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width:214,
    height:50,
    display:'block',
    margin:'40px auto 0px !important',
    '&:hover':{
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    }
  },
  addPatientList:{
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width:214,
    height:50,
    marginTop:-25,
    marginRight:25,
    display:'block',
    '&:hover':{
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    }
  },
  shareSwitch:{
    color: theme.palette.primary.main,
  },
  cancelButton:{
    color: theme.palette.error.main,
  },
  addButton:{
    color: theme.palette.primary.main,
  },
  container:{
    maxHeight:250,
    overflowY: 'auto',
    margin:'20px auto 20px',
    textAlign:'center',
    '& *':{
      textAlign:'center',
    }
  },
  dynamicVarListItem:{
    marginBottom:20
  }
}));

const AdminGreenSwitch = withStyles(theme =>({
  switchBase: {
    color: theme.palette.primary.dark,
    '&$checked': {
      color: theme.palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);
const AdminGreenTextField = withStyles(theme =>({
  root: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  },
}))(TextField);

const ManagePermissionsDialog = ({forceOpen = false, setForceOpen, refetch, user, invisible, title = undefined}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(invisible);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [email, setEmail] = useState('');
  
  useEffect(()=>{
    setOpen(forceOpen)
  },[forceOpen])
  
  const handleToggleOpen = useCallback(() => {
    setOpen(!open);
    if(forceOpen && open){
      setForceOpen(undefined)
    }
  },[open, forceOpen, setForceOpen]);
  
  const handleInputChange = useCallback((event) => {
    setEmail(event.target.value);
  },[]);
  
  const handleSave = useCallback(() => {
    const cleanEmail = email.trim();
    if(cleanEmail.length > 3){
      setSaving(true);
     // postVerifiedDomain(cleanEmail).then(()=>{
        setSaved(true);
        setSaving(false);
        setOpen(false);
        setEmail('')
        refetch();
     // })
    }
  },[email]);
  
  const [rows, setRows] = useState([
    {
      type:'contacts.view',
      value: true
    },
    {
      type:'contacts.edit',
      value: true
    },
    {
      type:'contacts.delete',
      value: false
    },
    
    {
      type:'campaigns.view',
      value: true
    },
    {
      type:'campaigns.edit',
      value: true
    },
    {
      type:'campaigns.delete',
      value: true
    },
    {
      type:'campaigns.publish',
      value: true
    },
  
    {
      type:'inbox.view',
      value: true
    },
    {
      type:'inbox.edit',
      value: true
    },
    {
      type:'inbox.delete',
      value: true
    },
    {
      type:'inbox.publish',
      value: true
    },
  
    {
      type:'templates.view',
      value: true
    },
    {
      type:'templates.edit',
      value: true
    },
    {
      type:'templates.delete',
      value: true
    },
    {
      type:'organization_settings.view',
      value: true
    },
    {
      type:'organization_settings.edit',
      value: true
    },
    {
      type:'organization_members.view',
      value: true
    },
    {
      type:'organization_members.edit',
      value: true
    },
    {
      type:'organization_members.delete',
      value: true
    },
    {
      type:'api_keys.view',
      value: true
    },
    {
      type:'api_keys.edit',
      value: true
    },
    {
      type:'verified_domains.view',
      value: true
    },
    {
      type:'verified_domains.edit',
      value: true
    },
    {
      type:'billing_settings.view',
      value: true
    },
    {
      type:'billing_settings.edit',
      value: true
    },
  ])
  
//  const groups = [...new Set(rows.map(item=>item.type.split('.')[0]))] // re-sorts when all are empty or all are false
  const groups = ['contacts', 'campaigns', 'inbox', 'templates', 'organization_settings', 'organization_members', 'api_keys', 'verified_domains', 'billing_settings'] // force the order
  
  const updateValue = useCallback((permission, type)=>{
    let modifiedRow =  rows.filter(item=>item.type.includes(permission) && item.type.includes(type))[0]
    const otherRows =  rows.filter(item=>item.type != modifiedRow.type)
    modifiedRow.value = !modifiedRow.value
    setRows([...otherRows, modifiedRow])
  },[rows])
  
  const retrieveValue = useCallback((permission, type)=>{
    return rows.filter(item=>item.type.includes(permission) && item.type.includes(type))[0].value
  },[rows])
  
  const doesExist = useCallback((permission, type)=>{
    return Boolean(rows.filter(item=>item.type.includes(permission) && item.type.includes(type))[0])
  },[rows])
  
  return (
    <>
      {!invisible && <Button variant={'contained'} color={'primary'} onClick={handleToggleOpen} disabled={open || saving}>
        {title ?? 'Manage Permissions'}
      </Button>}
      <Dialog
        maxWidth={'sm'}
        fullWidth={true}
        open={open}
        onClose={handleToggleOpen}
        aria-labelledby="add-verified-domain-dialog-form" className={classes.form}
      >
        <DialogTitle id="add-verified-domain-dialog-title"><Key/>Manage Permissions for: {user.first_name} {user.last_name}</DialogTitle>
        <DialogContent>
          {
            saving ?
              <ProgressBar style={{margin:'50px auto 50px'}}/>
              :
              <>
                <DialogContentText>
                  User Roles allow you to quickly assign permissions for your teammates.
                </DialogContentText>
                <form noValidate>
                  <TableContainer component={Box}>
                    <Table className={classes.table} aria-label="member permissions" size="small" >
                      <TableHead>
                        <TableRow>
                          <TableCell>Type</TableCell>
                          <TableCell align="center">View</TableCell>
                          <TableCell align="center">Manage</TableCell>
                          <TableCell align="center">Delete</TableCell>
                          <TableCell align="center">Send</TableCell>
                        </TableRow>
                      </TableHead>
  
                      {groups.map((item) => {
                        const permission = false; //item.type.split('.')[1]
                        return <TableBody key={item}>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              {(() => {
                                switch (item) {
                                  case 'contacts':
                                    return 'Contacts & Contact Lists'
                                  default:
                                    return toCapitalizeFromUnderScore(item)
                                }
    
                              })()}
                            </TableCell>
                            <TableCell align="center">{ doesExist(item, 'view') && <Switch checked={retrieveValue(item, 'view')} onChange={()=>updateValue(item, 'view')} /> }</TableCell>
                            <TableCell align="center">{ doesExist(item, 'edit') && <Switch checked={retrieveValue(item, 'edit')} onChange={()=>updateValue(item, 'edit')} /> }</TableCell>
                            <TableCell align="center">{ doesExist(item, 'delete') && <Switch checked={retrieveValue(item, 'delete')} onChange={()=>updateValue(item, 'delete')} /> }</TableCell>
                            <TableCell align="center">{ doesExist(item, 'publish') && <Switch checked={retrieveValue(item, 'publish')} onChange={()=>updateValue(item, 'publish')} /> }</TableCell>
                          </TableRow>
                        </TableBody>
                      })}
                      
                      
                    </Table>
                  </TableContainer>
                
                </form>
              </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleToggleOpen}
                  className={classes.cancelButton}
                  disabled={saving}>
            Cancel
          </Button>
          <Button onClick={handleSave}
                  className={classes.addButton}
                  disabled={saving}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      
    </>
  );
}

export default ManagePermissionsDialog;
